if (!customElements.get('popup-modal')) {
  customElements.define('popup-modal', class PopupModal extends HTMLElement {
    constructor() {
      super();
      this.storageItemName = 'whiskThemePromoPopup';
      this.debugMode = this.dataset.debugMode === 'true';

      const overridePopup = document.querySelector('[data-popup-override-enabled="true"]');
      if (overridePopup && overridePopup !== this) return;

      this.querySelectorAll('[data-close-popup]').forEach((button) => button.addEventListener('click', this.close.bind(this)));

      if (!this.debugMode && localStorage.getItem(this.storageItemName) === this.dataset.modalId) return;
      this.showModal();
    }

    showModal() {
      const modal = this;
      const liveUrl = window.location.href;

      // Check if customer is on a captcha page, if so, don't show the modal
      const captchaPage = liveUrl.includes('challenge');
      if (captchaPage) return;

      // Check if the customer is coming from a form submission so the modal can be shown immediately with the response
      const formSubmission = liveUrl.includes('form_type=customer') || liveUrl.includes('customer_posted=true');

      let delay_in_milliseconds = parseInt(this.dataset.delay, 10) * 1000;

      if (formSubmission) {
        delay_in_milliseconds = 1;
        modal.classList.add('with-form-response');
      }

      modal.addEventListener('transitionend', () => {
        modal.focus();
        trapFocus(modal);
      }, { once: true });

      modal.removeAttribute('hidden');

      setTimeout(() => {
        document.documentElement.classList.add('promo-popup-open');
        modal.classList.add('animate-in');
      }, delay_in_milliseconds);
    }

    storeKey() {
      const key = this.dataset.modalId;
      localStorage.setItem(this.storageItemName, key);
    }

    hideModal() {
      this.classList.remove('animate-in');
      document.documentElement.classList.remove('promo-popup-open');
      removeTrapFocus();

      setTimeout(() => {
        this.setAttribute('hidden', '');
      }, 500);
    }

    close() {
      this.hideModal();

      if (!Shopify.designMode && !this.debugMode) {
        this.storeKey();
      }
    }
  }
)};
